/**
 * Allowed types of videos
 */
export const VIDEO_TYPE_SKILL = 'skill';
export const VIDEO_TYPE_TUTORIAL = 'tutorial';
export const VIDEO_TYPE_INDY_TOPIC_KEY_SKILL_VIDEO = 'indy_topic_key_skill_video';

export type VideoType =
    | typeof VIDEO_TYPE_SKILL
    | typeof VIDEO_TYPE_TUTORIAL
    | typeof VIDEO_TYPE_INDY_TOPIC_KEY_SKILL_VIDEO;
